import { reactive } from "vue";

export const leadsState = reactive({
  currentLeadId: undefined,
});
